import { useTranslation } from '@wix/wix-i18n-config';
import { HttpClient } from '@wix/http-client';
import React, { useEffect, useState } from 'react';
import { useInitialState } from '../../../contexts/InitialStateContext';
import { Template } from '../../../domain/entities/template';
import { Loader } from '../../Loader/Loader';
import CloseIcon from './close.svg';
import s from './TemplateSaved.scss';
import { templatePreviewModalDataHooks } from '../TemplatePreviewModal.dataHooks';

type Props = {
  onCloseClick: () => void;
  onButtonClick: () => void;
  savedTemplate: Template;
};

export const TemplateSaved: React.FC<Props> = ({
  onCloseClick,
  onButtonClick,
  savedTemplate,
}) => {
  const { t } = useTranslation();
  const { baseUrl: baseURL, userData } = useInitialState();

  const [isLoading, setIsLoading] = useState(true);

  const thumbnail = savedTemplate.assets.find(
    (item) => item.type === 'RESPONSIVE_TALL',
  )?.absoluteUrl;

  useEffect(() => {
    const encodedUrl = encodeURIComponent(
      window.location.href + `?savedTemplateSlug=${savedTemplate.slug}`,
    );
    const signInUrl = `https://users.wix.com/signin?studio=true&view=sign-up&loginCompName=SignUp_H&postSignUp=${encodedUrl}&postLogin=${encodedUrl}&forceRender=true`;

    if (!userData.isLoggedIn) {
      return window.location.assign(signInUrl);
    }

    const doSendEmail = async () => {
      setIsLoading(true);
      try {
        const httpClient = new HttpClient({
          baseURL,
        });
        await httpClient.post<{ url: string }>('/api/template-mailer/send', {
          templatePreviewImg: thumbnail,
          templateMetaSiteId: savedTemplate.metaSiteId,
          templateId: savedTemplate.templateId,
          esid: '', // NOTE: unknown value???
        });
      } catch (e) {
        onCloseClick();
      }
      setIsLoading(false);
    };

    doSendEmail();
  }, []);

  return (
    <div
      className={s.TemplateSaved}
      data-hook={templatePreviewModalDataHooks.templateSaved()}
    >
      {isLoading ? (
        <div className={s.loaderWrapper}>
          <Loader />
        </div>
      ) : (
        <>
          <div className={s.header} onClick={onCloseClick}>
            <CloseIcon />
          </div>

          <div className={s.page}>
            <div className={s.imageContainer}>
              <img
                src={thumbnail}
                alt={savedTemplate.title}
                className={s.templateImage}
              />
            </div>

            <div className={s.content}>
              <div className={s.texts}>
                <div className={s.title}>
                  {t('app.templates.templateSavedPage.title')}
                </div>

                <div className={s.subtitle}>
                  {t('app.templates.templateSavedPage.subtitle')}
                </div>
              </div>

              <div className={s.buttonContainer}>
                <button onClick={onButtonClick} className={s.button}>
                  {t('app.templates.templateSavedPage.browseMoreButton.text')}
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
